import { useState } from "react";
import { useAppContext } from "../../../../context/AuthContext";
import { Teacher } from "../../../../controller";
import DataInterface from "../../../../interfaces/statistics/AdminStatisticsType";
import FeedbackStatisticsType from "../../../../interfaces/statistics/FeedbackStatisticsType";
import MessageType from "../../../../utils/MessageType";
import { useEffectOnce } from "../../../../utils/Utils";

interface StatisticsAdminServiceExport {
  data: Array<DataInterface>;
  feedbackStatistics?: FeedbackStatisticsType;
}

export default function StatisticsAdminService(): StatisticsAdminServiceExport {
  const { showMessage } = useAppContext();
  const [data, setData] = useState<Array<DataInterface>>([]);
  const [feedbackStatistics, setFeedbackStatistics] = useState<FeedbackStatisticsType>();

  useEffectOnce(() => {
    Teacher.getAdminStatistics()
      .then(({ data }) => {
        const filter = data.data;//.filter(({ creator }: DataInterface) => creator.username !== "pedja");
        setData(filter);
      })
      .catch((err: any) => showMessage(err.response?.data, MessageType.ERROR));

    Teacher.getFeedbackStatistics()
      .then(({ data }) => setFeedbackStatistics(data.data))
      .catch((err: any) => showMessage(err.response?.data, MessageType.ERROR));
  });

  return { data, feedbackStatistics };
}

export type { StatisticsAdminServiceExport };
